<template>
  <div>
    <v-bottom-sheet v-model="appDialog" persistent >
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title class="pink--text font-weight-bold">Explore Our Apps</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('closeAppDialog')">
            <v-icon color="pink">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- <v-text-field v-model="searchQuery" label="Search your language or region" prepend-inner-icon="mdi-magnify"
            clearable color="pink" class="mb-4" /> -->

          <v-row dense>
            <v-col v-for="app in filteredApps" :key="app.id" cols="12" sm="6" class="mb-3">
              <v-card outlined @click="goToApp()">
                <v-row no-gutters>
                  <v-col cols="4">
                    <v-img :src="app.icon" height="80" contain class="ma-3 rounded"></v-img>
                  </v-col>
                  <v-col cols="8" class="mt-5">
                    <div>
                      <div class="text-subtitle-1 font-weight-bold">
                        {{ app.name }}
                      </div>

                      <div class="text-body-2 primary--text">
                        Free Dating • Zero Payment
                      </div>

                    </div>
                    <div>

                      <span>{{ app.description }}</span>
                    </div>
                  </v-col>
          <v-col cols="12">
  <v-btn
    block
    large
    class="white--text"
    color="pink"
  >
    <v-icon left>mdi-download</v-icon>
  Download Now – It's Free!
  </v-btn>
  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <div v-if="filteredApps.length === 0" class="text-center text-grey mt-4">
            <v-icon large class="mb-2">mdi-emoticon-sad-outline</v-icon><br />
            No app found .
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  props: {
    appDialog: Boolean,
  },
  data() {
    return {
      searchQuery: '',
      apps: [
        {
          name: 'ProfileMatcher',
          icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg', // replace with real image
         description: 'A free Dating app for Indians',
          link: 'https://play.google.com/store/apps/details?id=com.profilematcher.tamil',
        },

        // {
        //   name: 'ProfileMatcher Matrimony (Tamil)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Tamil partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.tamil',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Telugu)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your Telugu life partner with ease and trust.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.telugu',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Kannada)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Match with Kannada-speaking brides and grooms today.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.kannada',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Malayalam)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Kerala’s trusted matrimony platform at no cost.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.malayalam',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Hindi)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'India’s most loved Hindi matrimony service.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.hindi',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Marathi)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Free matrimony for Marathi-speaking singles.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.marathi',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Bengali)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'The most trusted Bengali matchmaking platform.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.bengali',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Assamese)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Join thousands of Assamese singles for free.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.assamese',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Odia)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Connect with genuine Odia profiles today.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.odia',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Rajasthani)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Royal matches for the Rajasthani community.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.rajasthani',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Bihari)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find verified Bihari brides and grooms.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.bihari',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Kashmiri)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Trusted Kashmiri matrimonial service.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.kashmiri',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Haryanvi)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Meet serious Haryanvi marriage seekers.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.haryanvi',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Sindhi)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Connect with the vibrant Sindhi community.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.sindhi',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Goan)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Explore free matrimonial matches in Goa.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.goan',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Urdu)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find Urdu-speaking soulmates effortlessly.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.urdu',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Bodo)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Matrimony platform for the Bodo community.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.bodo',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Santhali)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find Santhali brides and grooms easily.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.santhali',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Manipuri)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find genuine Manipuri marriage profiles.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.manipuri',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Meitei)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Meitei matches made easy and secure.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.meitei',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Dogri)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Free matrimony service for Dogri speakers.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.dogri',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Konkani)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Meet Konkani partners from your region.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.konkani',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Nepali)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Trusted platform for Nepali-speaking singles.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.nepali',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Tulu)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your ideal Tulu-speaking partner.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.tulu',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Sikkimese)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Sikkim’s best matrimonial platform for free.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.sikkimese',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Nagaland)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Zero-payment matchmaking in Nagaland.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.nagaland',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Mizo)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Meet Mizo life partners with zero cost.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.mizo',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Tripuri)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find a trusted Tripuri match now.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.tripuri',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Jharkhandi)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Free matrimony service for Jharkhandi youth.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.jharkhandi',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Chhattisgarhi)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Connect with Chhattisgarhi matches nearby.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.chhattisgarhi',
        // },

        // {
        //   name: 'ProfileMatcher Matrimony (Andhra Pradesh)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Andhra Pradesh partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.andhra',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Arunachal Pradesh)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Arunachal Pradesh partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.arunachal',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Assam)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Assamese partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.assam',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Bihar)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Bihari partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.bihar',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Chhattisgarh)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Chhattisgarhi partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.chhattisgarh',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Goa)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Goan partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.goa',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Gujarat)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Gujarati partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.gujarat',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Haryana)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Haryanvi partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.haryana',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Himachal Pradesh)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Himachali partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.himachal',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Jharkhand)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Jharkhandi partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.jharkhand',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Karnataka)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Kannada partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.karnataka',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Kerala)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Malayali partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.kerala',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Madhya Pradesh)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect MP partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.madhya',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Maharashtra)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Marathi partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.maharashtra',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Manipur)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Manipuri partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.manipur',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Meghalaya)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Meghalayan partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.meghalaya',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Mizoram)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Mizo partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.mizoram',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Nagaland)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Naga partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.nagaland',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Odisha)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Odia partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.odisha',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Punjab)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Punjabi partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.punjab',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Rajasthan)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Rajasthani partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.rajasthan',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Sikkim)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Sikkimese partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.sikkim',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Tamil Nadu)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Tamil partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.tamil',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Telangana)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Telugu partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.telangana',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Tripura)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Tripuri partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.tripura',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Uttar Pradesh)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect UP partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.up',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Uttarakhand)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Uttarakhandi partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.uttarakhand',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (West Bengal)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Bengali partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.bengal',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Delhi)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Delhiite partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.delhi',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Jammu & Kashmir)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Kashmiri partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.kashmir',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Ladakh)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Ladakhi partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.ladakh',
        // },
        // {
        //   name: 'ProfileMatcher Matrimony (Puducherry)',
        //   icon: 'https://profilematcher.s3.ap-south-1.amazonaws.com/ApplcationImages/Pmlogo.jpg',
        //   description: 'Find your perfect Puducherry partner with ProfileMatcher Matrimony.',
        //   link: 'https://play.google.com/store/apps/details?id=com.profilematcher.puducherry',
        // }

        // Add more apps as needed...
      ],
    };
  },
  computed: {
    filteredApps() {
      const query = this.searchQuery.toLowerCase();
      return this.apps.filter(app => app.name.toLowerCase().includes(query));
    },
  },
  methods: {
    goToApp() {
      // For external Play Store
      this.$router.push("/playstore")

      // If routing internally:
      // this.$router.push(`/apps/${app.id}`);
    },
  },
};
</script>

<style scoped>

</style>
